import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store'
import { MessageBox } from 'element-ui'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '',
    redirect: '/index.html'
  },
  {
    path: '/index.html',
    name: 'index',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', code: 'login.index', noCache: true }
  },
  {
    path: '/bind.html',
    name: 'bind',
    component: () => import('@/views/login/bind.vue'),
    meta: { title: '用户绑定', code: 'login.index', noCache: true }
  },
  {
    path: '/hexin/confirm.html',
    name: 'hexin-confirm',
    component: () => import('@/views/hexin/confirm.vue'),
    meta: { title: '确认登录', code: 'hexin.confirm', noCache: true }
  },
  {
    path: '/xiangrong/confirm.html',
    name: 'xiangrong-confirm',
    component: () => import('@/views/xiangrong/confirm.vue'),
    meta: { title: '确认登录', code: 'xiangrong.confirm', noCache: true }
  },
  {
    path: '/xiangrong/sso.html',
    name: 'xiangrong-sso',
    component: () => import('@/views/xiangrong/sso.vue'),
    meta: { title: '登录跳转', code: 'xiangrong.sso', noCache: true }
  },
  {
    path: '/error/api-not-available',
    name: 'api-not-available',
    component: () => import('@/views/error/api-not-available.vue'),
    meta: { title: '服务不可用', code: 'usc.dashboard.error.apinotavailable', notNeedProfile: true, noCache: true }
  }
]

export const notFoundPage = {
  path: '*',
  name: 'page-not-found',
  component: () => import('@/views/error/page-not-found.vue'),
  meta: { title: '页面不存在', code: 'error.pagenotfound', noCache: true }
}

const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

router.addRoute(notFoundPage)

NProgress.configure({ showSpinner: false })

router.beforeEach(async (to, from, next) => {
  if (to.meta.notNeedProfile) {
    document.title = to.meta.title
    next()
    return
  }

  NProgress.start()

  if (store.getters.backend.product_name) {
    document.title = `${to.meta.title} - ${store.getters.backend.product_name}`
  } else {
    document.title = to.meta.title
  }

  const profileLoaded = !!store.getters.backend.product_code
  if (profileLoaded) {
    next()
  } else {
    store.dispatch('login/loadprofile').then(() => {
      next({ ...to, replace: true })
    }).catch(err => {
      store.dispatch('login/pusherror', {
        message: err,
        lastpath: to.path
      }).finally(() => {
        next({ name: 'api-not-available', replace: true, query: { path: to.path } })
        NProgress.done()
      })
    })
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router

router.onError((error) => {
  const chunkFailedPattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(chunkFailedPattern)
  console.log(error)
  if (isChunkLoadFailed) {
    MessageBox.alert('检测到应用已更新版本，点击确定后刷新页面', '更新提示', {
      confirmButtonText: '确 定',
      callback: action => {
        if (action === 'confirm') {
          window.location.reload(true)
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js